module.exports = __webpack_public_path__ + "static/media/passesCompanyEURAIL_backup.0022b39c.svg";